import {
  ExitToApp as ExitToAppIcon,
  Logout as LogoutIcon,
  Help as HelpIcon,
  Person as PersonIcon,
  Dashboard as DashboardIcon,
} from '@mui/icons-material';

export const SideMenuList = [
  {
    to: '/ambulatorio',
    key: 'Ambulatorio',
    icon: () => <DashboardIcon />,
    label: 'Ambulatorio',
  },
  {
    to: '/internaciones',
    key: 'Internaciones',
    icon: () => <DashboardIcon />,
    label: 'Internaciones',
  },
  {
    to: '/protesis',
    key: 'Prótesis',
    icon: () => <DashboardIcon />,
    label: 'Prótesis',
  },
  {
    to: '/medicamentos',
    key: 'Medicamentos',
    icon: () => <DashboardIcon />,
    label: 'Medicamentos',
  },
];

export const BottomMenuListAyuda = [
  // {
  //   to: '/ayuda',
  //   key: 'Ayuda',
  //   icon: () => <HelpIcon />,
  //   label: 'Ayuda',
  // },
];

export const BottomMenuList = [
  {
    to: '/signout',
    key: 'Salir',
    icon: () => <ExitToAppIcon />,
    label: 'Salir',
  },
];

export const TopMenuList = [
  {
    to: '/perfil',
    key: 'Perfil',
    icon: () => <PersonIcon fontSize='small' />,
    label: 'Perfil',
  },
  {
    to: '/signout',
    key: 'Salir',
    icon: () => <LogoutIcon fontSize='small' />,
    label: 'Salir',
  },
];
